import { INFORMATION_API } from '../constants/api';
import {  GET_PROXY } from '../functions/superagentSending';

const initialState = {
    loading: true,
    meta: {},
    data: {
        workTimes: [],
        gallery: []
    },
    error: '',
};

const FETCH_INFORMATION_REQUEST = 'FETCH_INFORMATION_REQUEST';
const FETCH_INFORMATION_SUCCESS = 'FETCH_INFORMATION_SUCCESS';
const FETCH_INFORMATION_FAILURE = 'FETCH_INFORMATION_FAILURE';

const fetchInfromationRequest = () => ({
    type: FETCH_INFORMATION_REQUEST,
});

const fetchInfromationSuccess = (data) => ({
    type: FETCH_INFORMATION_SUCCESS,
    payload: data,
});

const fetchInfromationFailure = (error) => ({
    type: FETCH_INFORMATION_FAILURE,
    payload: error,
});

const InformationReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_INFORMATION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    ...payload.data,
                    gallery: [
                        ...(state?.data?.gallery || []),
                        ...(payload?.data?.gallery || []),
                    ]
                },
                meta: payload.meta,
                error: '',
            };
        case FETCH_INFORMATION_FAILURE:
            return {
                loading: false,
                meta: {},
                data: {},
                error: payload,
            };
        default:
            return state;
    }
};

export const FETCH_INFORMATION_REDUCER = (page) => {
    return (dispatch) => {
        dispatch(fetchInfromationRequest());
        // console.log('work')
        // { page}
        GET_PROXY(INFORMATION_API,
            (success) => {
                dispatch(fetchInfromationSuccess(success));
            },
            (error) => {
                dispatch(fetchInfromationFailure(error));
                dispatch(fetchInfromationFailure(''));
            })
    };
};

export default InformationReducer;
